import "./src/styles/global.css"
import '@fontsource/source-sans-3/400.css';
import '@fontsource/source-sans-3/700.css';
import '@fontsource/source-sans-3/400-italic.css';
import '@fontsource/source-serif-4/400-italic.css';

export const shouldUpdateScroll = () => false;
